import { ModuleWithProviders, NgModule, Type, inject } from '@angular/core';
import { BLOB_STORAGE_TOKEN_SERVICE, BlobStorageService, IBlobStorageTokenService } from './blob-storage.service';

@NgModule({
  providers: [BlobStorageService],
})
export class BlobStorageModule {
  static forRoot(params: { tokenService: Type<IBlobStorageTokenService> }): ModuleWithProviders<BlobStorageModule> {
    return {
      ngModule: BlobStorageModule,
      providers: [
        {
          provide: BLOB_STORAGE_TOKEN_SERVICE,
          useClass: params.tokenService,
        },
      ],
    };
  }
  constructor() {
    const module = inject(BlobStorageModule, { skipSelf: true, optional: true });

    if (module) throw new Error(`import ${BlobStorageModule.name} once in the app.module!`);
  }
}
